import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import '@/i18n'

import { ConvexProvider } from "convex/react";
import { ConvexReactClient } from "convex/react";
import { AuthProvider } from "@/contexts/AuthContext";
import { CompanyProvider } from "@/contexts/CompanyContext";
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import ErrorBoundary from "@/components/ErrorBoundary";

// Force dark mode — no light theme
localStorage.setItem('core829-theme', 'dark');
document.documentElement.classList.add('dark');

// Global error handler for non-React errors (e.g. uncaught TDZ, network, etc.)
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

const convexUrl = import.meta.env.VITE_CONVEX_URL;

if (!convexUrl) {
    throw new Error("Missing VITE_CONVEX_URL environment variable. Check your .env or Vercel dashboard.");
}

const convex = new ConvexReactClient(convexUrl, {
    // Pass the current session token to Convex. The Convex custom auth provider
    // (auth.config.ts) validates our RS256 JWT via the JWKS endpoint, then maps
    // it to a user identity that all queries/mutations can read via
    // ctx.auth.getUserIdentity(). The backend's getCurrentUserFromCookie also
    // falls back to the session cookie, so the two paths work together.
    getAuth: () => {
        try {
            return sessionStorage.getItem("c829_session_token") || null;
        } catch {
            return null;
        }
    },
});

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ErrorBoundary>
            <ConvexProvider client={convex}>
                <AuthProvider>
                    <CompanyProvider>
                        <CurrencyProvider>
                            <App />
                        </CurrencyProvider>
                    </CompanyProvider>
                </AuthProvider>
            </ConvexProvider>
        </ErrorBoundary>
    </React.StrictMode>,
)